import { Box, Typography } from "@mui/material";
import { useState } from "react";
import AndOrFilter from "../../components/filters/AndOrFilter";

const mockOptions = [
  { name: "X", label: "Option X", displayName: "Option X" },
  { name: "Y", label: "Option Y", displayName: "Option Y" },
  { name: "Z", label: "Option Z", displayName: "Option Z" },
];

const AndOrFilterDemo = () => {
  const [appliedFilters, setAppliedFilters] = useState({ myField: {} });
  const [filterLogic, setFilterLogic] = useState({ myField: "OR" });

  // Get selected values as array of keys with truthy values
  const selected = Object.keys(appliedFilters.myField || {}).filter(
    (k) => appliedFilters.myField[k]
  );

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="subtitle1">AndOrFilter Example</Typography>
      <AndOrFilter
        filterName="My Filter"
        fieldName="myField"
        options={mockOptions}
        appliedFilters={appliedFilters}
        setAppliedFilters={setAppliedFilters}
        setFilterLogic={setFilterLogic}
      />
      <Typography variant="body2">
        Selected: {selected.length ? selected.join(", ") : "None"} | Logic:{" "}
        {filterLogic.myField}
      </Typography>
    </Box>
  );
};

export default AndOrFilterDemo;
